module.exports = __webpack_public_path__ + "static/bg_trust-335a1ab287be65371f4a31b110079a29.jpg";